<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { Button } from '@Shelly/shelly-design-system/index';
	import { format } from 'svelte-i18n';
	import ZoneConfigInputs from '../subcomponents/ZoneConfigInputs.svelte';
	import type { Device } from 'src/types/Device';

	export let zoneId: number;
	export let zoneColor: number[] | null = null;
	export let settings: any;
	export let device: Device;
	export let saving: boolean = false;

	const dispatch = createEventDispatcher();

	let inputsRef: ZoneConfigInputs;
	let hasChanges = false;

	function handleDiscard() {
		inputsRef?.resetChanges();
	}

	/** Call after room zone config was persisted successfully so Save/Discard hide again. */
	export function acknowledgeSaved() {
		inputsRef?.acknowledgeSaved();
	}
</script>

<div class="draw-sidebar">
	<p class="draw-sidebar__title">
		<span
			class="draw-sidebar__dot"
			style="background:{zoneColor ? `rgb(${zoneColor.join(',')})` : '#fff'}"
		></span>
		{$format('presence_room_settings_title', { default: 'Room settings' })}
	</p>

	<ZoneConfigInputs
		bind:this={inputsRef}
		bind:hasChanges
		showSaveButton={false}
		on:configSave={(e) => dispatch('save', e.detail)}
		{settings}
		{device}
		{zoneId}
		isMainZone={true}
	/>

	<div class="draw-sidebar__actions">
		{#if hasChanges}
			<Button variant="secondary" size="m" on:click={handleDiscard} disabled={saving}>
				{$format('button_discard', { default: 'Discard' })}
			</Button>
			<Button
				aria-label="save"
				variant="primary"
				size="m"
				on:click={() => inputsRef?.handleConfigSave()}
				disabled={saving || !hasChanges}
			>
				{#if saving}
					<i class="fas fa-spinner fa-spin" aria-hidden="true"></i>
					{$format('button_saving', { default: 'Saving…' })}
				{:else}
					{$format('button_save', { default: 'Save' })}
				{/if}
			</Button>
		{:else}
			<Button variant="secondary" size="m" on:click={() => dispatch('return')}
				>{$format('button_return', { default: 'Return' })}</Button
			>
		{/if}
	</div>
</div>

<style>
	.draw-sidebar {
		padding: 12px 14px 8px;
		display: flex;
		flex-direction: column;
		gap: 14px;
	}

	.draw-sidebar__title {
		font-size: 16px;
		font-weight: 600;
		color: #eaeaea;
		display: flex;
		align-items: center;
		gap: 10px;
		margin: 0;
	}

	.draw-sidebar__dot {
		width: 16px;
		height: 16px;
		border-radius: 50%;
		flex-shrink: 0;
		display: inline-block;
	}

	.draw-sidebar__actions {
		display: flex;
		gap: 8px;
		justify-content: flex-end;
	}
</style>
